import {calcularImporteLinea, redondear2} from "../helpers/money.utils";

// Estado constants
export const ESTADO_PENDIENTE = 1;
export const ESTADO_ACEPTADO = 2;
export const ESTADO_ENTREGADO_PARCIAL = 3;
export const ESTADO_ENTREGADO_COMPLETO = 4;
export const ESTADO_CANCELADO = 5;

// Tipo constants
export const TIPO_ORDINARIO = 1;
export const TIPO_FACTURA_PREVIA = 2;
export const TIPO_A_CUENTA = 3;

// Estado de facturación constants
export const ESTADO_FACTURACION_SIN_FACTURAR = 0;
export const ESTADO_FACTURACION_TOTAL = 2;

// Business rules
export const puedeAceptarPresupuesto = presupuesto =>
    Number(presupuesto?.codigoEstado) === ESTADO_PENDIENTE;

export const puedeRechazarPresupuesto = (presupuesto) => presupuesto?.puedeCancelar === true;

export const aplicarCancelacion = (local, cancelado) => ({
  ...local,
  codigoEstado: cancelado.codigoEstado,
  lastModifiedOn: cancelado.lastModifiedOn,
  puedeCancelar: cancelado.puedeCancelar
});

export const esAceptacionParcial = (idsMarcados = [], totalLineas = 0) =>
  idsMarcados.length > 0 && idsMarcados.length < totalLineas;


export const puedeGenerarFactura = (presupuesto) => {
  if (presupuesto?.codigoEstado !== ESTADO_ACEPTADO) return false;

  const tipo = Number(presupuesto.codigoTipo);
  const facturacion = presupuesto.codigoEstadoFacturacion;
  if (tipo === TIPO_FACTURA_PREVIA) return facturacion !== ESTADO_FACTURACION_TOTAL;
  if (tipo === TIPO_A_CUENTA) return facturacion === ESTADO_FACTURACION_SIN_FACTURAR;
  return false;
};

export const admiteReservas = (presupuesto) =>
  Number(presupuesto?.codigoTipo) !== TIPO_A_CUENTA;

// Selectors
// El destinatario natural es la persona del contacto; el correo del cliente es el genérico
// de la empresa y solo sirve de respaldo
export const selectEmailDestinatario = (presupuesto) =>
  presupuesto?.contacto?.email ||
  presupuesto?.cliente?.email ||
  presupuesto?.emailCliente ||
  "";

export const selectClienteNombre = (presupuesto) =>
  presupuesto?.cliente?.nombre || presupuesto?.clienteNombre || "";

export const selectContactoNombre = (presupuesto) => presupuesto?.contacto?.nombre || '';

// Helpers
export const makePresupuestoEmailBody = (presupuesto, plantilla, usuario) => {
  if (!plantilla) return '';

  const nombreContacto = selectContactoNombre(presupuesto);
  const numeroDocumento = presupuesto?.codigoPresupuesto || '';
  const nombreEmpleado = usuario?.nombreCompleto || '';
  const emailUsuario = usuario?.email || '';

  return plantilla
    .replace(/\{0\}/g, nombreContacto)
    .replace(/\{1\}/g, numeroDocumento)
    .replace(/\{2\}/g, nombreEmpleado)
    .replace(/\{3\}/g, emailUsuario);
};

const hasText = value => Boolean(value && value.trim && value.trim());

const trimmedText = value =>
    typeof value === "string" ? value.trim() : "";

export const nombreDireccionEnvio = direccion =>
    trimmedText(direccion?.nombre) ||
    trimmedText(direccion?.atencion) ||
    trimmedText(direccion?.localidad) ||
    trimmedText(direccion?.lineasDireccion) ||
    "Dirección sin referencia";

export const nombreDireccionFacturacion = direccion =>
    trimmedText(direccion?.nombre) ||
    trimmedText(direccion?.localidad) ||
    trimmedText(direccion?.lineasDireccion) ||
    "Dirección sin referencia";

export const direccionNoSeleccionada = () => ({mode: "none"});

export const direccionGuardada = direccion => ({
  mode: "saved",
  id: direccion.id,
  preview: direccion
});

export const direccionPersonalizada = direccion => ({
  mode: "custom",
  value: direccion
});

// Una ficha del cliente sin línea de dirección no cuenta como enlace: el documento usa su copia
export const fichaTieneDireccion = ficha => hasText(ficha?.lineasDireccion);

export const AVISO_FICHA_SIN_DIRECCION =
    "La dirección elegida no tiene línea de dirección: complétela para usarla en el documento";

// La provincia queda sin elegir a propósito: preseleccionar una la persiste como si el
// usuario la hubiese escogido, y acaba impresa en el PDF.
export const makeEmptyDireccionEnvio = () => ({
  organizacion2: "",
  lineasDireccion: "",
  codigoPostal: "",
  localidad: "",
  telefono: "",
  email: "",
  idPais: 1,
  idProvincia: null
});

export const CODIGOS_ADMINISTRACION_CAMPOS = [
  {name: "codigoSef", label: "Código SEF (e-factura)"},
  {name: "oficinaContable", label: "Oficina contable (DIR3)"},
  {name: "organoGestor", label: "Órgano gestor (DIR3)"},
  {name: "unidadTramitadora", label: "Unidad tramitadora (DIR3)"}
];

export const CAMPOS_FACTURAE_DIRECCION = [
  {name: "nombreFiscal", label: "Nombre fiscal / razón social", maxLength: 250},
  {name: "nombrePersona", label: "Nombre (persona física)", maxLength: 40},
  {name: "primerApellido", label: "Primer apellido", maxLength: 40},
  {name: "segundoApellido", label: "Segundo apellido", maxLength: 40},
  {name: "direccionFacturae", label: "Dirección abreviada para Facturae", maxLength: 80},
  {name: "localidadFacturae", label: "Localidad abreviada para Facturae", maxLength: 50}
];

export const makeEmptyDireccionFacturacion = () => ({
  ...makeEmptyDireccionEnvio(),
  nombreFiscal: "",
  nombrePersona: "",
  primerApellido: "",
  segundoApellido: "",
  direccionFacturae: "",
  localidadFacturae: "",
  cif: "",
  oficinaContable: "",
  organoGestor: "",
  unidadTramitadora: "",
  codigoSef: ""
});

export const mapDireccionClienteToDocumento = dto => ({
  organizacion2: dto?.organizacion2 || "",
  lineasDireccion: dto?.lineasDireccion || "",
  codigoPostal: dto?.codigoPostal || "",
  localidad: dto?.localidad || "",
  telefono: dto?.telefono || "",
  email: dto?.email || "",
  idPais: dto?.idPais || 1,
  idProvincia: dto?.idProvincia || null,
  nombreFiscal: dto?.nombreFiscal || "",
  nombrePersona: dto?.nombrePersona || "",
  primerApellido: dto?.primerApellido || "",
  segundoApellido: dto?.segundoApellido || "",
  direccionFacturae: dto?.direccionFacturae || "",
  localidadFacturae: dto?.localidadFacturae || "",
  cif: dto?.cif || "",
  oficinaContable: dto?.oficinaContable || "",
  organoGestor: dto?.organoGestor || "",
  unidadTramitadora: dto?.unidadTramitadora || "",
  codigoSef: dto?.codigoSef || ""
});

export const mapDireccionEnvioClienteToDocumento = dto => ({
  ...mapDireccionClienteToDocumento(dto),
  atencion: dto?.atencion || "",
  observaciones: dto?.observaciones || ""
});

export const mapDireccionFacturacionClienteToDocumento = dto => ({
  ...mapDireccionClienteToDocumento(dto),
  observaciones: dto?.observaciones || ""
});

const direccionDocumentoLimpia = (direccion, esFacturacion) => ({
  organizacion2: trimmedText(direccion?.organizacion2) || null,
  lineasDireccion: trimmedText(direccion?.lineasDireccion),
  codigoPostal: trimmedText(direccion?.codigoPostal),
  localidad: trimmedText(direccion?.localidad),
  telefono: trimmedText(direccion?.telefono) || null,
  email: trimmedText(direccion?.email) || null,
  observaciones: trimmedText(direccion?.observaciones) || null,
  idPais: Number(direccion?.idPais) || null,
  idProvincia: direccion?.idProvincia ? Number(direccion.idProvincia) : null,
  ...(esFacturacion
      ? {
        nombreFiscal: trimmedText(direccion?.nombreFiscal) || null,
        nombrePersona: trimmedText(direccion?.nombrePersona) || null,
        primerApellido: trimmedText(direccion?.primerApellido) || null,
        segundoApellido: trimmedText(direccion?.segundoApellido) || null,
        direccionFacturae: trimmedText(direccion?.direccionFacturae) || null,
        localidadFacturae: trimmedText(direccion?.localidadFacturae) || null,
        cif: trimmedText(direccion?.cif),
        oficinaContable: trimmedText(direccion?.oficinaContable) || null,
        organoGestor: trimmedText(direccion?.organoGestor) || null,
        unidadTramitadora: trimmedText(direccion?.unidadTramitadora) || null,
        codigoSef: trimmedText(direccion?.codigoSef) || null
      }
      : {atencion: trimmedText(direccion?.atencion) || null})
});

export const direccionDesdePresupuesto = (id, copia) => {
  if (id) return {mode: "saved", id, preview: null};
  if (copia) return direccionPersonalizada(copia);
  return direccionNoSeleccionada();
};

export const direccionesPresupuestoSoloLectura = presupuesto =>
    [ESTADO_ENTREGADO_COMPLETO, ESTADO_CANCELADO].includes(Number(presupuesto?.codigoEstado));

// seleccion.preview es la copia del presupuesto; ficha es null si no se pudo cargar
export const direccionTrasCargarFicha = (seleccion, ficha, cerrada) => {
  if (seleccion?.mode !== "saved" || !ficha) return seleccion;
  if (!fichaTieneDireccion(ficha)) {
    return seleccion.preview ? direccionPersonalizada(seleccion.preview) : direccionNoSeleccionada();
  }
  return cerrada && seleccion.preview ? {...seleccion, sinResolver: false} : direccionGuardada(ficha);
};

export const buildPresupuestoDireccionesPayload = (
    presupuesto,
    direccionEnvio,
    direccionFacturacion
) => ({
  ...presupuesto,
  idDireccionEnvio:
      direccionEnvio?.mode === "saved" ? direccionEnvio.id : null,
  presupuestosDireccionesEnvio:
      direccionEnvio?.mode === "custom"
          ? direccionDocumentoLimpia(direccionEnvio.value, false)
          : null,
  idDireccionFacturacion:
      direccionFacturacion?.mode === "saved" ? direccionFacturacion.id : null,
  presupuestosDireccionesFacturacion:
      direccionFacturacion?.mode === "custom"
          ? direccionDocumentoLimpia(direccionFacturacion.value, true)
          : null
});

export const mismasDireccionesPresupuesto = (iniciales, actuales) =>
    JSON.stringify(buildPresupuestoDireccionesPayload({}, iniciales.envio, iniciales.facturacion)) ===
    JSON.stringify(buildPresupuestoDireccionesPayload({}, actuales.envio, actuales.facturacion));

export const tieneCifFacturacion = direccion => hasText(direccion?.cif);

export const conservaFacturacionHeredada = (inicial, actual) => {
  if (!inicial || inicial.mode !== actual?.mode) return false;
  if (inicial.mode === "saved") {
    return inicial.id === actual.id && !tieneCifFacturacion(inicial.preview) &&
        !tieneCifFacturacion(actual.preview);
  }
  if (inicial.mode !== "custom" || tieneCifFacturacion(inicial.value)) return false;
  const anterior = direccionDocumentoLimpia(inicial.value, true);
  const siguiente = direccionDocumentoLimpia(actual.value, true);
  return Object.keys(anterior).every(campo => anterior[campo] === siguiente[campo]);
};

export const validateDireccionSelections = (
    direccionEnvio, direccionFacturacion, exigeCif = false
) => {
  const result = validatePresupuestoDirecciones(
        buildPresupuestoDireccionesPayload({}, direccionEnvio, direccionFacturacion)
    );
  const facturacion = direccionFacturacion?.mode === "saved"
      ? direccionFacturacion.preview : direccionFacturacion?.value;
  if (exigeCif && !tieneCifFacturacion(facturacion)) {
    result.isValid = false;
    result.validation.facturacion = {
      isValid: false,
      message: "Debe completar una dirección de facturación con CIF antes de guardar el presupuesto"
    };
  }
  for (const [tipo, seleccion] of [["envio", direccionEnvio], ["facturacion", direccionFacturacion]]) {
    if (seleccion?.mode === "saved" && seleccion.sinResolver) {
      result.validation[tipo] = {
        isValid: false,
        message: "No se pudo cargar la dirección. Seleccione otra o vuelva a intentarlo"
      };
    }
  }
  result.isValid = result.validation.envio.isValid && result.validation.facturacion.isValid;
  return result;
};

export const createPresupuestoWizardDraft = contacto => ({
  contacto,
  direccionEnvio: direccionNoSeleccionada(),
  direccionFacturacion: direccionNoSeleccionada()
});

export const applyDireccionFieldChange = (direccion = {}, name, value) => {
  const nextValue =
      name === "idPais"
          ? value
              ? parseInt(value, 10)
              : 1
          : name === "idProvincia"
              ? value
                  ? parseInt(value, 10)
                  : null
              : value;

  const nextDireccion = {
    ...direccion,
    [name]: nextValue
  };

  if (name === "idPais" && nextValue !== 1) {
    nextDireccion.idProvincia = null;
  }

  return nextDireccion;
};

export const validatePresupuestoDirecciones = presupuesto => {
  let isValid = true;
  const validation = {
    envio: {isValid: true, message: ""},
    facturacion: {isValid: true, message: ""}
  };

  const hasEnvioSelected = !!presupuesto?.idDireccionEnvio;
  const envio = presupuesto?.presupuestosDireccionesEnvio;
  const hasEnvioData =
      hasText(envio?.lineasDireccion) &&
      hasText(envio?.localidad) &&
      hasText(envio?.codigoPostal);

  if (!hasEnvioSelected && !hasEnvioData) {
    validation.envio = {
      isValid: false,
      message: "Debe seleccionar o crear una dirección de envío"
    };
    isValid = false;
  }

  // El CIF no entra aquí: hay instantáneas heredadas que lo tienen vacío y esta
  // comprobación solo decide si hay dirección, no si está completa
  const hasFacturacionSelected = !!presupuesto?.idDireccionFacturacion;
  const facturacion = presupuesto?.presupuestosDireccionesFacturacion;
  const hasFacturacionData =
      hasText(facturacion?.lineasDireccion) &&
      hasText(facturacion?.localidad) &&
      hasText(facturacion?.codigoPostal);

  if (!hasFacturacionSelected && !hasFacturacionData) {
    validation.facturacion = {
      isValid: false,
      message: "Debe seleccionar o crear una dirección de facturación"
    };
    isValid = false;
  }

  return {isValid, validation};
};

export const calcularPrecioConDescuento = (cantidad, precioUnitario, porcentajeDescuento) =>
    calcularImporteLinea(cantidad, precioUnitario, porcentajeDescuento);

export const calcularSubtotal = (productos = []) => {
  const subtotal = productos.reduce(
      (acc, producto) =>
          acc + (Number(producto.cantidadPedida) || 0) * (Number(producto.precioUnitario) || 0),
      0
  );
  return redondear2(subtotal);
};

export const calcularTotal = (productos = []) => {
  const total = productos.reduce(
      (acc, producto) =>
          acc +
          calcularPrecioConDescuento(
              producto.cantidadPedida,
              producto.precioUnitario,
              producto.porcentajeDescuento
          ),
      0
  );
  return redondear2(total);
};

export const calcularDescuento = (productos = []) =>
    redondear2(calcularSubtotal(productos) - calcularTotal(productos));

export const calcularMargenLinea = (cantidad, precioUnitario, porcentajeDescuento, precioCompra) => {
  const precioConDto = calcularPrecioConDescuento(cantidad, precioUnitario, porcentajeDescuento);
  const compra = Number(precioCompra) || 0;
  const unidades = Number(cantidad) || 1;
  return (precioConDto / unidades - compra) * unidades;
};

export const esCantidadLineaValida = (cantidad) => {
  const unidades = Number(cantidad);
  return Number.isInteger(unidades) && unidades >= 1;
};

/**
 * Recuento de lo marcado en el selector de productos, indexado por fila
 */
export const resumirSeleccionProductos = (seleccion = {}) => {
  const marcadas = Object.values(seleccion);

  return {
    lineas: marcadas.length,
    unidades: marcadas.reduce(
        (total, {cantidad}) =>
            total + (esCantidadLineaValida(cantidad) ? Number(cantidad) : 0),
        0
    ),
    hayCantidadInvalida: marcadas.some(({cantidad}) => !esCantidadLineaValida(cantidad))
  };
};

/** Traduce la selección del modal al cuerpo que espera el alta en lote. */
export const mapSeleccionALineasPresupuesto = (seleccion = {}) =>
    Object.values(seleccion).map(({producto, cantidad}) => ({
      idProducto: producto.id,
      idProveedor: producto.proveedor?.id || producto.productoProveedor?.idProveedor || null,
      cantidad: Number(cantidad),
      nombre: producto.nombre,
      precioVenta: producto.precioVenta,
      iva: producto.iva
    }));

/**
 * Resultado del alta en lote en palabras
 */
export const makeProductosAnadidosMensaje = (resultado = {}) => {
  const creadas = Number(resultado.lineasCreadas) || 0;
  const incrementadas = Number(resultado.lineasIncrementadas) || 0;
  const partes = [];

  if (creadas > 0) {
    partes.push(creadas === 1 ? "1 producto añadido" : `${creadas} productos añadidos`);
  }
  if (incrementadas > 0) {
    partes.push(incrementadas === 1
        ? "1 línea existente con más unidades"
        : `${incrementadas} líneas existentes con más unidades`);
  }

  return partes.length > 0 ? partes.join(" y ") : "No se añadió ningún producto";
};

/**
 * Aviso cuando el correo salió pero sin alguno de los adjuntos de producto
 */
export const makeAdjuntosOmitidosMensaje = (adjuntosOmitidos) => {
  const omitidos = Number(adjuntosOmitidos) || 0;
  if (omitidos <= 0) return null;

  return omitidos === 1
      ? "Correo enviado, pero 1 adjunto de producto no estaba disponible y no se ha incluido."
      : `Correo enviado, pero ${omitidos} adjuntos de producto no estaban disponibles y no se han incluido.`;
};

export const construirObservacionesIniciales = (...textos) =>
    textos
        .filter(texto => typeof texto === "string" && texto.trim() !== "")
        .map(texto => texto.replace(/\r\n?/g, "\n").trim())
        .join("\n");

export const PRESUPUESTO_ENCABEZADOS = [
  {name: "encabezado", label: "Encabezado"},
  {name: "encabezadoAlbaran", label: "Encabezado Albarán"},
  {name: "encabezadoFactura", label: "Encabezado Factura"}
];

export const validatePresupuestoEncabezados = presupuesto => {
  const campo = PRESUPUESTO_ENCABEZADOS.find(
      ({name}) => (presupuesto?.[name] || "").length > 255
  );
  return campo ? `${campo.label} no puede superar los 255 caracteres.` : null;
};

export const tieneEncabezadosSinGuardarParaFacturar = (actual, guardado) => {
  const campos = Number(guardado?.codigoTipo) === TIPO_A_CUENTA
      ? ["encabezadoFactura", "encabezadoAlbaran"] : ["encabezadoFactura"];
  return campos.some(campo => (actual?.[campo] || "") !== (guardado?.[campo] || ""));
};
